// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpService } from './../../core/services/http.service';
import { LoadingRoleDetailsAction, OrgLoadingRoleDetailsAction } from './role-details.actions';
import { QueueAlertAction, AlertType, GoAction, RoleGroup, RoleDetail } from '@app/core';
import { Store, select } from '@ngrx/store';
import { SelectGroupAction } from './group-details/group-details.actions';
import { selectRoleDetail } from '.';
import { take, filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../core/services/http.service";
var RoleDetailsFacadeService = /** @class */ (function () {
    function RoleDetailsFacadeService(store, httpService) {
        this.store = store;
        this.httpService = httpService;
    }
    RoleDetailsFacadeService.prototype.initialize = function (roleId) {
        var _this = this;
        this.roleDetailsData$ = this.store.pipe(select(selectRoleDetail(roleId)));
        this.roleDetailsData$
            .pipe(filter(function (data) { return !data || !data.role || !data.policies; }), take(1))
            .subscribe(function () { return _this.store.dispatch(new LoadingRoleDetailsAction(roleId)); });
        this.role$ = this.roleDetailsData$.pipe(filter(function (data) { return !!data; }), map(function (data) { return data.role; }));
        this.rolePolicies$ = this.roleDetailsData$.pipe(filter(function (data) { return !!data; }), map(function (data) { return data.policies; }));
    };
    RoleDetailsFacadeService.prototype.initializeOrgRoles = function (orgId, roleId) {
        var _this = this;
        this.roleDetailsData$ = this.store.pipe(select(selectRoleDetail(roleId)));
        this.roleDetailsData$
            .pipe(filter(function (data) { return !data || !data.role; }), take(1))
            .subscribe(function () { return _this.store.dispatch(new OrgLoadingRoleDetailsAction({ orgId: orgId, roleId: roleId })); });
        this.role$ = this.roleDetailsData$.pipe(filter(function (data) { return !!data; }), map(function (data) { return data.role; }));
    };
    RoleDetailsFacadeService.prototype.getRoleGroups = function (roleId) {
        return this.httpService.get(this.httpService.urls.roles.roleGroups, { urlParam: roleId });
    };
    RoleDetailsFacadeService.prototype.refreshRole = function (roleId) {
        this.store.dispatch(new LoadingRoleDetailsAction(roleId));
    };
    RoleDetailsFacadeService.prototype.removeRolePolicySuccess = function (roleId) {
        this.refreshRole(roleId);
        this.store.dispatch(new QueueAlertAction({ alertText: "Policy delete succeed.", alertType: AlertType.SUCCESS }));
    };
    RoleDetailsFacadeService.prototype.removeRolePolicyError = function () {
        this.store.dispatch(new QueueAlertAction({ alertText: "Policy delete failed.", alertType: AlertType.ERROR }));
    };
    RoleDetailsFacadeService.prototype.goToRoleGroupScopes = function (roleId, group) {
        this.store.dispatch(new SelectGroupAction(group));
        this.store.dispatch(new GoAction(['/iam/roles', roleId, 'groups', group.group_id]));
    };
    RoleDetailsFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function RoleDetailsFacadeService_Factory() { return new RoleDetailsFacadeService(i0.inject(i1.Store), i0.inject(i2.HttpService)); }, token: RoleDetailsFacadeService, providedIn: "root" });
    return RoleDetailsFacadeService;
}());
export { RoleDetailsFacadeService };



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-details.facade.ts.pre-build-optimizer.js